module.exports = __webpack_public_path__ + "img/DEL-full-color-logo.1c9cd936.png";